import React, { useEffect, useRef, useState } from "react";
import logo from "../../assets/images/logo.png";
import logo2 from "../../assets/images/logo2.png";
import defaultUser from "../../assets/images/Default_user_image.png";
import { SearchOutlined } from "@mui/icons-material";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import useLocalStorage from "use-local-storage";
import Toggle from "../../Toggle";
import HomeSharpIcon from "@mui/icons-material/HomeSharp";
import WorkSharpIcon from "@mui/icons-material/WorkSharp";
import axios from "../.././API/axios";
import GobalSearch from "../../khojpages/GlobalSearch/GobalSearch";

import CloseIcon from '@mui/icons-material/Close';
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

NonLoginHeader.propTypes = {};

function NonLoginHeader({ clname = "", handleMobile }) {
  const [isDark, setIsDark] = useLocalStorage("isDark", false);
  const dropdownRef1 = useRef(null);
  const [scroll, setScroll] = useState(0);

  useEffect(() => {
    document.addEventListener("scroll", () => {
      const scrollCheck = window.scrollY > 100;
      if (scrollCheck !== scroll) {
        setScroll(scrollCheck);
      }
    });
  }, []);
  const [inputValue, setInputValue] = useState("");
  const [searchUser, setSearchUser] = useState([]);
  const [searchComp, setSearchComp] = useState([]);
  const [searchJob, setSearchJob] = useState([]);
  const [options, setOptions] = useState([]);
  const [page, setPage] = useState(1);
  const [searchPost, setSearchPost] = useState([]);

  const addOptions = () => {
    axios
      .get(`/Feature/GlobalSearch?search=${inputValue}`)
      .then((response) => {
        let data = response.data.data;
        data = data.map((item) => {
          const [type, followers] = item.type.split(",");
          return {
            ...item,
            type,
            followers: parseInt(followers, 10),
          };
        });
        const addUniqueItems = (data, type) => {
          const uniqueItems = data.filter((item) => item.type === type);
          return uniqueItems;
        };
        setSearchUser(addUniqueItems(data, "User"));
        setSearchComp(addUniqueItems(data, "Company"));
        setSearchJob(addUniqueItems(data, "Job"));
        setSearchPost(addUniqueItems(data, "Post"));
        setOptions((prev) => {
          const postSet = new Set(prev.map((post) => post.id));
          const uniqueNewPosts = data.filter((post) => !postSet.has(post.id));
          return [...prev, ...uniqueNewPosts];
        });
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  };

  useEffect(() => {
    if (inputValue) {
      addOptions(page);
    } else {
      setOptions([]);
      setSearchUser([]);
      setSearchComp([]);
      setSearchJob([]);
      setSearchPost([]);
    }
  }, [inputValue, page]);

  const handleInfiniteScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } = dropdownRef1.current;
    if (scrollTop + clientHeight >= scrollHeight - 1) {
      setPage((prev) => prev + 1);
    }
  };

  useEffect(() => {
    if (dropdownRef1.current) {
      dropdownRef1.current.addEventListener("scroll", handleInfiniteScroll);
      return () =>
        dropdownRef1.current.removeEventListener(
          "scroll",
          handleInfiniteScroll
        );
    }
  }, [dropdownRef1]);

  const searchContainerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef1.current &&
        !dropdownRef1.current.contains(event.target) &&
        searchContainerRef.current &&
        !searchContainerRef.current.contains(event.target)
      ) {
        setOptions([]);
        setInputValue("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const navigate = useNavigate();
    const location = useLocation();
    
    const handleNavigation = (path) => {
      if (location.pathname === path) {
      window.location.reload(); // Force a full page reload
      } else {
      navigate(path);
      }
    };
    const [open, setOpen] = useState(false);
    
      // Open Modal
      const handleOpen = () => setOpen(true);
    
      // Close Modal
      const handleClose = () => setOpen(false);
    

  return (
    <>
     {/* <header id="header" className="header header-default container header-fixed"> */}
    <header
      id="header"
      className={`header pt-3 loginkhojHeader header-default login-mobile-header-style khojdesktopHeader home-page-main-text`}>
      <div className="px-4 ct2">
        <div className="row">
          <div className="col-md-12">
            <div className="sticky-area-wrap sticky-nav-wrap-section">
              <div className="header-ct-left">
                {isDark ? (
                  <div id="logo" className="logo">
                    <Link to="/Home" onClick={() => handleNavigation("/Home")}>
                      <img
                        className="site-logo"
                        id="trans-logo"
                        src={logo2}
                        alt="Image"
                      />
                    </Link>
                  </div>
                ) : (
                  <div id="logo" className="logo">
                    <Link to="/" onClick={() => handleNavigation("/Home")}>
                      <img
                        className="site-logo"
                        id="trans-logo"
                        src={logo}
                        alt="Image"
                      />
                    </Link>
                  </div>
                )}
              </div>

              {/* Search container */}

              <div className="form-group-1 khojSearch d-flex align-items-center me-2">
                <GobalSearch />
                
              </div>

              {/******************           Search closed       ***********************/}

              <div className="header-ct-center">
                <div className="nav-wrap">
                  <nav id="main-nav" className="main-nav">
                    <ul
                      id="menu-primary-menu"
                      className={`menu mb-2 ${clname}`}
                    >
                      <li className="menu-item  sub1">
                        <Link to="/Home" onClick={() => handleNavigation("/Home")}>
                        <HomeSharpIcon />
                        <NavLink to="/Home">Home</NavLink>
                        </Link>
                      </li>
                      <li className="menu-item subjob">
                        <Link to="/Jobs"  >
                        <WorkSharpIcon />
                        <NavLink to="/Jobs">Jobs</NavLink>
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
              <div className="header-ct-right mobile-not-register-class">
                <Toggle
                  isChecked={isDark}
                  handleChange={() => setIsDark(!isDark)}
                  className="desktopToggle"
                />
                <div className="btns">

                  <Link to="/Login" className="">
                <div className="khojPrimaryBtn ms-3">
                    Login
                </div>
                  </Link>
                <div className="form-group-4 ms-3">
                    <Link to="/Register" className="">
                     <div className="khojSecondaryBtn nonlogin-khojSecondaryBtn">
                      Register
                     </div>
                    </Link>
                </div>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <div className="ms-auto mobileToggle me-2">
                  <Toggle
                    isChecked={isDark}
                    handleChange={() => setIsDark(!isDark)}
                  />
                </div>
                <div className="nav-filter" onClick={handleMobile}>
                  <div className="nav-mobile">
                    <span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    	<header
				id="header"
				className={`header khojmobileHeader pt-3 header-default loginkhojHeader header-fixed ${scroll ? "is-fixed is-small" : ""
					}`}
			>
				<div className="px-4 ct2">
					<div className="row">
						<div className="col-md-12">
							<div className="sticky-area-wrap">
								<div className="header-ct-left">
									<div className="nav-wrap">
										<nav id="main-nav" className="main-nav profileNav">
											<ul
												id="menu-primary-menu"
												className={`menu profileMenu mb-2 ${clname} Nav-Header-Mobile mt-1`}
											>
												<li className="menu-item menu-item-has-children">
													 
													<div className="nav-filter" onClick={handleMobile}>
														<div className="nav-mobile">
															<span></span>
														</div>
													</div>

												</li>
											</ul>
										</nav>
									</div> 
								</div>
								<div className="form-group-1 khojSearch d-flex align-items-center">
									<GobalSearch />

								</div>


								<div className="header-ct-right">
									{/* <TopNotification /> */}
									<div className="ms-auto me-2 mobileToggle">
										<Toggle
											isChecked={isDark}
											handleChange={() => setIsDark(!isDark)}
										/>
									</div>
									 
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>

      {/* Modal for Search-Mobile*/}
			<Modal
				open={open}
				aria-labelledby="search-modal-title"
				aria-describedby="search-modal-description"
				className="search-modal-inner-description"
			>
				<Box
					className="search-modal-inner-description"
					sx={{
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						bgcolor: "background.paper",
						border: "2px solid #000",
						boxShadow: 24,
						borderRadius: "8px",
					}}
				>
					<div className="Search-Mobile-Responsive-Title d-flex ">
						<h2 id="search-modal-title" style={{ marginBottom: "16px" }}>
							Search
						</h2>
						<CloseIcon className="CloseIcon-Search-Mobile" onClick={handleClose} />
					</div>

					{/* GobalSearch Component */}
					<div id="search-modal-description" className="GobalSearch-search-modal">
						<GobalSearch />
					</div>
				</Box>
			</Modal>
    </>
   

    
  );
}

export default NonLoginHeader;
